import { XDatePickerDropdown } from '@adornis/datetime/x-date-picker-dropdown.js';
import { customElement } from 'lit/decorators.js';
import { DateTime } from 'luxon';

/**
 * @customElement cr-date-picker-dropdown
 */
@customElement('cr-date-picker-dropdown')
export class ChromiumDatePickerDropdown extends XDatePickerDropdown {
  override highlightedDate = (date: DateTime) => {
    return date.hasSame(DateTime.now(), 'day');
  };
}
